import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const fetchGroups = async () => {
  const { data } = await axiosInstance.get('/promethee_admin/groups/');
  return data;
};

export const useGetGroups = (options = {}) =>
  useQuery({
    queryKey: ['admin', 'groups'],
    queryFn: fetchGroups,
    enabled: options.enabled ?? true,
    staleTime: 10 * 60_000,
    refetchOnWindowFocus: false,
  });
